import { apiClient } from '../api-client';
import type { ApiResponse } from '@/types/api';
import type { Location, CreateLocationRequest, UpdateLocationRequest } from '@/types/inventory';

export const locationsApi = {
  getAll: async (isActive?: boolean) => {
    const params = isActive !== undefined ? { isActive } : undefined;
    const response = await apiClient.get<ApiResponse<Location[]>>('/locations', { params });
    return response.data.data;
  },

  getById: async (id: number) => {
    const response = await apiClient.get<ApiResponse<Location>>(`/locations/${id}`);
    return response.data.data;
  },

  create: async (data: CreateLocationRequest) => {
    const response = await apiClient.post<ApiResponse<Location>>('/locations', data);
    return response.data.data;
  },

  update: async (id: number, data: UpdateLocationRequest) => {
    const response = await apiClient.put<ApiResponse<Location>>(`/locations/${id}`, data);
    return response.data.data;
  },

  bulkUpdateActive: async (ids: number[], isActive: boolean) => {
    const response = await apiClient.put<ApiResponse<null>>('/locations/bulk-update', { ids, isActive });
    return response.data;
  },

  delete: async (id: number, strategy: string, targetLocationId?: number) => {
    await apiClient.delete(`/locations/${id}`, {
      data: { strategy, targetLocationId },
    });
  },

  restore: async (id: number) => {
    await apiClient.post(`/locations/${id}/restore`);
  },
};
